import { c as _c } from "react/compiler-runtime";
import styles from "./VehicleImageLabels.module.css";
interface VehicleImageLabelsProps {
  statusLabel?: string | null;
}
export default function VehicleImageLabels(t0) {
  const $ = _c(4);
  const {
    statusLabel
  } = t0;
  if (!statusLabel) {
    return null;
  }
  let t1;
  if ($[0] !== statusLabel) {
    t1 = statusLabel && <span className={styles.status}>{statusLabel}</span>;
    $[0] = statusLabel;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className={styles.overlay}>{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}